import { ChangeDetectionStrategy, Component } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { ButtonModule, DialogModule, DialogRef, DialogService } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  templateUrl: "./bv-remove-password-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule, I18nPipe],
  host: {
    class: "bv-remove-password-dialog-host",
  },
})
export class BvRemovePasswordDialogComponent {
  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  protected close(result: boolean): void {
    void this.dialogRef.close(result);
  }

  static open(dialogService: DialogService): Promise<boolean> {
    const dialogRef = dialogService.open<boolean>(BvRemovePasswordDialogComponent, {});
    return firstValueFrom(dialogRef.closed).then((result) => result ?? false);
  }
}
